import React from "react";
import { useNavigate } from "react-router-dom";

const MENU_ITEMS = [
  { title: "Introduction", desc: "Learn about Top Screen", route: "/introducing", icon: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" },
  { title: "The Problem", desc: "What we're solving", route: "/problem", icon: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
  { title: "Our Solution", desc: "How Top Screen works", route: "/solution", icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" },
  { title: "Important Info", desc: "Key details to know", route: "/important", icon: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
  { title: "Pricing", desc: "Plans and pricing", route: "/pricing", icon: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" },
  { title: "Install", desc: "Get the app", route: "/install", icon: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" },
  { title: "Examples", desc: "See it in action", route: "/examples", icon: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" },
  { title: "Contact Us", desc: "Get in touch", route: "/contact", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" },
  { title: "Press", desc: "Media and more", route: "/press", icon: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" },
  { title: "News Preferences", desc: "Pick & rank your ticker sources", route: "/news/preferences", icon: "M4 6h16M4 12h10M4 18h7" },
];

export default function MenuGrid() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="dashboard-grid">
      {MENU_ITEMS.map((item) => (
        <button
          key={item.route}
          onClick={() => navigate(item.route)}
          className="card-glass p-6 text-left group"
          data-testid={`dashboard-card-${item.route.slice(1)}`}
        >
          <div className="w-12 h-12 rounded-xl bg-[#A3E635]/10 flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
              <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
            </svg>
          </div>
          <h3 className="font-heading text-xl font-semibold text-white mb-2 group-hover:text-[#A3E635] transition-colors">
            {item.title}
          </h3>
          <p className="text-[#E8E4DC]">{item.desc}</p>
        </button>
      ))}
    </div>
  );
}
